import type { Module } from './api';

/**
 * Reports built before the formula was taken off the page still carry it in
 * their saved text: the price-rating formula note, "40% OF THE SCORE" tags,
 * "% of the score" captions, method weights and the weighting note (comments #51–#53). This
 * reads any saved module the way a fresh build would say it, so an old report
 * never shows how the scoring works.
 */
export function scrubModule(m: Module): Module {
  const note = /^Price rating: 70 means/.test(m.note ?? '')
    ? 'Not a valuation: the range the evidence supports for this property.'
    : /^Weighted across the/.test(m.note ?? '')
      ? 'Each measure is read from the module that measures it.'
      : m.note;
  return {
    ...m,
    note,
    rows: m.rows.map((r) => {
      // Method weights ("LOWER WEIGHT · 15% OF THE MIDPOINT") go the same way.
      if (/% OF THE MIDPOINT$/.test(r.t)) {
        const t = r.t.replace(/\s*·?\s*\d+% OF THE MIDPOINT$/, '');
        return { ...r, t: t || 'AN INPUT', s: r.s === 'an input, shown at the weight it carries' ? 'one of the inputs to the window' : r.s };
      }
      if (!/^\d+% OF THE SCORE$/.test(r.t)) return r;
      const n = Number(r.v);
      return { ...r, t: !Number.isFinite(n) ? 'NOT SCORED' : n >= 70 ? 'HOLDS' : n >= 45 ? 'MIXED' : 'AGAINST' };
    }),
    stats: m.stats.map((x) => (/% of the score/.test(x.s) ? { ...x, s: 'of 100' } : x)),
  };
}
